// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/background/scholarship_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scholarship-body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    /* background-position: bottom; */
    display: flex;
    height: 100vh;
    width: 100%;
    max-width: 100%;
}
.scholarship-body p{
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5;
    color: #FFFFFF;
    text-align: center;
}
.scholarship-body a {
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 2;
    color: #FFFFFF;
    text-decoration: none;
}
.scholarship-body a:hover {
    text-decoration: none;
    color: #FFFFFF;
    cursor: pointer;
}
.footerp{
    line-height: 1.5 !important;
    text-align: right !important;
}
.footer_contact{
    font-weight: bold!important;
    font-size: 26px!important;
}
.footer-section {
    bottom: 0%;
    margin-top: 200px;
}
.footer-rock {
    position: absolute;
    width: 400px !important;
    top: -30%;
    left: -20%;
    z-index: 1 !important;
}
.active-link {
    color: #FFFFFF;
    text-decoration: none;
}
@media (min-width:1000px) and (max-width:1100px) {
    @media  (min-height:600px) and (max-height:650px) {
        .footer-rock {
            width: 250px !important;
            top: -20% !important;
            left: -5% !important;
        }
    }
}
@media (min-width:1300px) and (max-width:1400px) {
    .footer-rock {
        position: absolute;
        width: 300px !important;
        top: -20%;
        left: -8% !important;
        z-index: 1 !important;
    }
}
@media (max-width:767px) {
    .footerp{
        text-align: left !important;
        margin-top: 20px;
    }
    .scholarship-body {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        /* height: 100vh; */
        width: 100%;
        max-width: 100%;
    }
    .footer-section {
        bottom: -100%;
        margin-top: 0px;
    }
    .footer-rock {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/components/scholarship.css"],"names":[],"mappings":"AAAA;IACI,yDAAmE;IACnE,4BAA4B;IAC5B,sBAAsB;IACtB,iCAAiC;IACjC,aAAa;IACb,aAAa;IACb,WAAW;IACX,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI;QACI;YACI,uBAAuB;YACvB,oBAAoB;YACpB,oBAAoB;QACxB;IACJ;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,SAAS;QACT,oBAAoB;QACpB,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;IACA;QACI,yDAAmE;QACnE,4BAA4B;QAC5B,sBAAsB;QACtB,2BAA2B;QAC3B,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".scholarship-body {\n    background-image: url(\"../../images/background/scholarship_bg.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    /* background-position: bottom; */\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    max-width: 100%;\n}\n.scholarship-body p{\n    font-family: 'Chakra Petch';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1.5;\n    color: #FFFFFF;\n    text-align: center;\n}\n.scholarship-body a {\n    font-family: 'Chakra Petch';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 2;\n    color: #FFFFFF;\n    text-decoration: none;\n}\n.scholarship-body a:hover {\n    text-decoration: none;\n    color: #FFFFFF;\n    cursor: pointer;\n}\n.footerp{\n    line-height: 1.5 !important;\n    text-align: right !important;\n}\n.footer_contact{\n    font-weight: bold!important;\n    font-size: 26px!important;\n}\n.footer-section {\n    bottom: 0%;\n    margin-top: 200px;\n}\n.footer-rock {\n    position: absolute;\n    width: 400px !important;\n    top: -30%;\n    left: -20%;\n    z-index: 1 !important;\n}\n.active-link {\n    color: #FFFFFF;\n    text-decoration: none;\n}\n@media (min-width:1000px) and (max-width:1100px) {\n    @media  (min-height:600px) and (max-height:650px) {\n        .footer-rock {\n            width: 250px !important;\n            top: -20% !important;\n            left: -5% !important;\n        }\n    }\n}\n@media (min-width:1300px) and (max-width:1400px) {\n    .footer-rock {\n        position: absolute;\n        width: 300px !important;\n        top: -20%;\n        left: -8% !important;\n        z-index: 1 !important;\n    }\n}\n@media (max-width:767px) {\n    .footerp{\n        text-align: left !important;\n        margin-top: 20px;\n    }\n    .scholarship-body {\n        background-image: url(\"../../images/background/scholarship_bg.png\");\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n        display: flex;\n        /* height: 100vh; */\n        width: 100%;\n        max-width: 100%;\n    }\n    .footer-section {\n        bottom: -100%;\n        margin-top: 0px;\n    }\n    .footer-rock {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
